module.exports = __webpack_public_path__ + "static/media/pay-pal.08844e55.svg";